export default __webpack_public_path__ + "static/media/profits.00b22859.svg";